import axios from '@/http/axios/index.js'


export default {
    getEntities(data) {
        return axios.get('budget/assign/entities')
    },
    getDepartaments(data) {
        return axios.get('budget/assign/departaments')
    },
    getYears(data) {
        return axios.get('budget/assign/years')
    },
    list(data) {
        return axios.get('budget/budget-category', { params: data })
    }


}



